
export const delayFromSchedule = (pollsDone: number, schedule: number[]): number =>
	schedule[Math.min(pollsDone, schedule.length - 1)];
